// @flow
import studySchema from "src/schemas/studySchema";
import { relationshipReducer } from "src/utils/reducerUtils";

export const studyRelationships = relationshipReducer({
  name: "studies",
  relationshipSchemas: studySchema.relationshipSchemas
});
